import React, { FunctionComponent, FC } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import { FontSizes } from '../../../../Theme/Fonts/FontTypes'
import NonFlexingContainer from '../../../../Layouts/NonFlexingContainer'

type IconProps = { fontSize?: FontSizes }

export const YellowCard: FC<IconProps> = ({ fontSize }) => (
    <FontelloIcon name="card-active" color="YELLOW" fontSize={fontSize} />
)

export const RedCard: FC<IconProps> = ({ fontSize }) => (
    <FontelloIcon name="card-active" color="RED" fontSize={fontSize} />
)

export const SecondYellowCard: FC<IconProps> = ({ fontSize }) => (
    <NonFlexingContainer position="relative">
        <RedCard fontSize={fontSize} />
        <NonFlexingContainer position="absolute">
            <FontelloIcon name="card-yellow-red" fontSize={fontSize} color="YELLOW" />
        </NonFlexingContainer>
    </NonFlexingContainer>
)

export const SubstitutionExchange: FC<{ fontSize: number }> = ({ fontSize }) => (
    <NonFlexingContainer position="relative" width={fontSize} height={fontSize}>
        <FontelloIcon name="arrow-left" color="GREEN" fontSize={fontSize / 2} />
        <NonFlexingContainer position="absolute" bottom={0} right={0}>
            <FontelloIcon name="arrow-right" fontSize={fontSize / 2} color="keshi-3" />
        </NonFlexingContainer>
    </NonFlexingContainer>
)

export const PenaltyMissed: FC<IconProps> = ({ fontSize }) => (
    <FontelloIcon name="close-x" fontSize={fontSize} color="onyx-4" />
)

export const PenaltyScored: FC<IconProps> = ({ fontSize }) => (
    <FontelloIcon name="penalty-scored" fontSize={fontSize} color="onyx-4" />
)

export const Substitution: FunctionComponent<IconProps> = ({ fontSize }) => (
    <FontelloIcon name="substitution" fontSize={fontSize} color="onyx-4" />
)

export const Whistle: FunctionComponent<IconProps> = ({ fontSize }) => (
    <FontelloIcon name="whistle" fontSize={fontSize} color="onyx-5" />
)

export const VideoProof: FunctionComponent<IconProps> = ({ fontSize }) => (
    <FontelloIcon name="video-proof-active" fontSize={fontSize} color="onyx-5" />
)

export const Goal: FunctionComponent<IconProps> = ({ fontSize }) => (
    <FontelloIcon name="soccer-goal-filled" fontSize={fontSize} color="onyx-5" />
)

export const Assist: FunctionComponent<IconProps> = ({ fontSize }) => (
    <FontelloIcon name="assist" fontSize={fontSize} color="onyx-5" />
)
